import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { ContactInfo, ContactForm, MapEmbed } from "../sections/ContactSection";
import { Reveal, usePageMeta } from "../lib/motion";

const ContactPage = () => {
  usePageMeta("Contact Us", "Contact The Trip World — immigration and visa consultancy in Ahmadgarh, Punjab. Call +91 99888 50202.");
  return (
    <main data-testid="contact-page">
      <PageHero
        eyebrow="CONTACT"
        title="LET'S START"
        highlight="YOUR JOURNEY"
        description="Visit our office in Ahmadgarh, call us, or send a message — your free consultation is one step away."
      />
      <section className="py-20 lg:py-28 bg-navy-deep">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            <Reveal><ContactInfo /></Reveal>
            <Reveal delay={0.15}><ContactForm /></Reveal>
          </div>
          <MapEmbed />
        </div>
      </section>
      <CtaBand />
    </main>
  );
};

export default ContactPage;
